import { render, staticRenderFns } from "./workshopAproval.vue?vue&type=template&id=640b421e&scoped=true&"
import script from "./workshopAproval.vue?vue&type=script&lang=js&"
export * from "./workshopAproval.vue?vue&type=script&lang=js&"
import style0 from "./workshopAproval.vue?vue&type=style&index=0&id=640b421e&prod&lang=scss&scoped=true&"
import style1 from "./workshopAproval.vue?vue&type=style&index=1&id=640b421e&prod&lang=css&"
import style2 from "./workshopAproval.vue?vue&type=style&index=2&id=640b421e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b421e",
  null
  
)

export default component.exports